// extracted by mini-css-extract-plugin
export var alignCenter = "_8l-d";
export var bannerShown = "_8l-6";
export var buttonContent = "_8l-0";
export var cardList = "_8l-1";
export var centerContent = "_8l-2";
export var chevron = "_8l-3";
export var closePanelButton = "_8l-k";
export var conversationContextContainer = "_8l-l";
export var conversationDetailContainer = "_8l-4";
export var detailWrapper = "_8l-7";
export var dropdownButton = "_8l-e";
export var dropdownTitle = "_8l-9";
export var fullHeight = "_8l-5";
export var hidden = "_8l-a";
export var icon = "_8l-b";
export var mergeSuggestionWrapper = "_8l-m";
export var panel = "_8l-i";
export var portalButtonsWrapper = "_8l-c";
export var right = "_8l-j";
export var tableSummaryContainer = "_8l-8";
export var tableSummaryHeader = "_8l-g";
export var threeDotsButton = "_8l-f";
export var wide = "_8l-h";